const ErrorPage = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <h1>Invalid Request</h1>
    </div>
  );
};

export default ErrorPage;
